import type { PersistStorage, StorageValue } from "zustand/middleware";
import type { AuthStoreState } from "./authStore";

export const authStorage: PersistStorage<AuthStoreState> = {
  getItem(name: string): StorageValue<AuthStoreState> | null {
    if (typeof localStorage === "undefined") return null;
    const data = localStorage.getItem(name);
    if (!data) return null;
    try {
      return JSON.parse(data) as StorageValue<AuthStoreState>;
    } catch {
      return null;
    }
  },

  setItem(name: string, value: StorageValue<AuthStoreState>): void {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(name, JSON.stringify(value));
  },

  removeItem(name: string): void {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(name);
  },
};
